import { Component } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';

interface HelpOption {
    icon: string;
    label: string;
    detail: string;
    link?: string;
    action?: () => void;
}

@Component({
    selector: 'app-help-sector',
    templateUrl: './help-sector.component.html',
    styleUrls: ['./help-sector.component.scss'],
    standalone: true,
    imports: [NgFor, NgIf]
})
export class HelpSectorComponent {

    helpOptions: HelpOption[] = [];

    constructor(private router: Router) {
        this.helpOptions = [
            {
                icon: 'assets/images/mail-open-love-outline.svg',
                label: 'Email us?',
                detail: 'support@nutrigenic.co.uk',
                link: 'mailto:support@nutrigenic.co.uk'
            },
            {
                icon: 'assets/images/help-chat.svg',
                label: 'Live Chat',
                detail: 'Leave a message',
                link: 'https://api.whatsapp.com/send?phone=4407538734145&text=Nutrigenic'
            },
            {
                icon: 'assets/images/help-question.svg',
                label: 'Have a question?',
                detail: 'Visit our FAQs page',
                action: () => this.router.navigate(['faq'])
            }
        ];
    }
}
